export const SUBMIT_PRODUCT_CPSRB_COMMENT_FORM = 'productCpsrbCommentForm/SUBMIT_PRODUCT_CPSRB_COMMENT_FORM';
